import { createListenerMiddleware } from "@reduxjs/toolkit";
import {
  addSongToSetlist,
  createNewEmptySetlist,
  createSetlistFromData,
  removeSetListFromSetlists,
  removeSongFromSetlist,
  renameSetlist,
  updateSetlistItemMetadata,
  updateSetlistItemSettings,
  updateSetlistStartFromSong,
  cacheSetlistAssetsAsync,
  uncacheSetlistAssetsAsync,
  saveUserSetlistsToS3Async,
} from "../features/setlists/setlistsSlice";

let doprint = false;
// let doprint = true;


export const setlistsS3SyncListener = createListenerMiddleware();

let saveTimer = null;

const scheduleSetlistsS3Save = (api, reason) => {
  if (saveTimer) {
    clearTimeout(saveTimer);
  }

  saveTimer = setTimeout(() => {
    const state = api.getState();
    const user = state.auth.user;

    if (window.localStorage.getItem("saveSetlists") !== "1") {
      if (doprint) console.log("[SETLISTS S3] skipped scheduled save because saveSetlists is not 1", {
        reason,
      });
      return;
    }

    if (!user || user.guest) {
      if (doprint) console.log("[SETLISTS S3] skipped scheduled save because user is not logged in", {
        reason,
      });
      return;
    }

    if (doprint) console.log("[SETLISTS S3] scheduled save triggered", {
      reason,
      count: state.setlists.setlists?.length || 0,
    });

    api.dispatch(saveUserSetlistsToS3Async()).unwrap().then(() => {
      if (doprint) console.log("[SETLISTS S3] scheduled save completed", {
        reason,
      });
    }).catch((e) => {
      console.error("[SETLISTS S3] scheduled save failed", e);
    });

  }, 800);
};

setlistsS3SyncListener.startListening({
  matcher: (action) => [
    addSongToSetlist.type,
    createNewEmptySetlist.type,
    createSetlistFromData.type,
    removeSetListFromSetlists.type,
    removeSongFromSetlist.type,
    renameSetlist.type,
    updateSetlistItemMetadata.type,
    updateSetlistItemSettings.type,
    updateSetlistStartFromSong.type,
    cacheSetlistAssetsAsync.fulfilled.type,
    uncacheSetlistAssetsAsync.fulfilled.type,
  ].includes(action.type),
  effect: async (action, api) => {
    scheduleSetlistsS3Save(api, action.type);
  },
});
